import { MAIN_PATH } from 'deviceSlaves/navigation';

const indexComponent = require('./routes/list/components/DeviceSlavesList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceSlavesManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/deviceSlaves/index.js